/* eslint-disable react/require-default-props */
import React from 'react';
import createTrack from 'services/actions/tracker_actions';
import { useDispatch } from 'react-redux';
import { MenusBehaviourTypes } from 'store/modules/menus_behaviour_store/types';
import LucideIcon from 'components/atoms/lucide_icon';
import { toolIconName } from 'components/atoms/lucide_icon/tool_icons';
import { Container } from './styles';

interface ServiceItemProps {
  name: string;
  icon: string;
  link: string;
  tagNew: boolean;
  variant?: 'row' | 'chip';
  onOpenModal?: (modal: 'resumo' | 'pergunte' | undefined) => void;
  onActivate?: (name: string) => void;
}

const ServiceItem: React.FC<ServiceItemProps> = ({
  name,
  icon,
  link,
  tagNew,
  variant = 'row',
  onOpenModal,
  onActivate,
}) => {
  const externalLinks: Record<string, string> = {
    'Artigos Jurídicos': 'https://conlicitacao.com.br/blog',
    'Cursos in Company': 'https://www.institutolicitar.com.br/in-company',
  };

  const dispatch = useDispatch();

  const isActionItem =
    name === 'Resumo do Edital' || name === 'Pergunte ao Edital' || name === 'Consultor Jurídico';

  return (
    <Container className={variant === 'chip' ? 'd-inline-flex' : ''}>
      {isActionItem ? (
        <button
          type="button"
          className={`tool-item tool-item--${variant}`}
          onClick={() => {
            onActivate?.(name);
            if (name === 'Resumo do Edital' && onOpenModal) {
              onOpenModal('resumo');
            } else if (name === 'Consultor Jurídico') {
              dispatch({ type: MenusBehaviourTypes.OPEN_CHATBOT_ASSISTANT });
            } else if (name === 'Pergunte ao Edital' && onOpenModal) {
              onOpenModal('pergunte');
            }
          }}
        >
          <LucideIcon name={toolIconName(icon, name)} size={18} />
          <span className="name">{name}</span>
          {tagNew && variant === 'row' && <span className="tag-new">Novo</span>}
        </button>
      ) : (
        <a
          href={externalLinks[name] || link}
          target={externalLinks[name] ? '_blank' : undefined}
          className={`tool-item tool-item--${variant}`}
          onClick={() => {
            onActivate?.(name);
            createTrack(`Novo Menu - Clicou na ferramenta ${name}`);
          }}
          rel="noreferrer"
        >
          <LucideIcon name={toolIconName(icon, name)} size={18} />
          <span className="name">{name}</span>
          {tagNew && variant === 'row' && <span className="tag-new">Novo</span>}
        </a>
      )}
    </Container>
  );
};
export default ServiceItem;
